module.exports = __webpack_public_path__ + "media/images/map-marker-unassigned-c6747d3f32d17bd5507b98f63fb473df.svg";